import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
var IdentityTypeDict = {
  'mobile': {
    'title': '手机号',
    'value': 'mobile',
    'tag': 'primary'
  },
  'username': {
    'title': '用户名/邮箱',
    'value': 'username',
    'tag': 'info'
  },
  'svc': {
    'title': '储值卡',
    'value': 'svc',
    'tag': 'success'
  }
};
import { getUserInfoList } from '@/api/bairun/userInfo'; //  此处请自行替换地址

import { getBairunUserGroupInfoAllListByLevel, changeUserGroup } from '@/api/bairun/userGroup'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';
import vueQr from 'vue-qr';

var _this;

export default {
  name: 'UserInfo',
  components: {
    vueQr: vueQr
  },
  mixins: [infoList],
  data: function data() {
    return {
      fullscreenLoading: false,
      path: path,
      listApi: getUserInfoList,
      type: '',
      bairunLogo: require('@/assets/bairun-logo.jpg'),
      userQrcodeText: '',
      identityTypeDict: IdentityTypeDict,
      qrcodeDialogVisible: false,
      userGroupDialogVisible: false,
      userGroupOptions: [],
      multipleSelection: [],
      formData: {
        mobile: '',
        userGroupId: ''
      },
      rules: {
        userGroupId: [{
          required: true,
          message: '请选择会员群',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  // eslint-disable-next-line vue/order-in-components
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatIdentityType: function formatIdentityType(type, res) {
      // eslint-disable-next-line no-prototype-builtins
      return IdentityTypeDict.hasOwnProperty(type) ? res === 'tag' ? IdentityTypeDict[type].tag : IdentityTypeDict[type].title : '';
    },
    getUserGroupNames: function getUserGroupNames(groupIds) {
      debugger;
      groupIds = groupIds + '';
      var groupArr = groupIds.split(',');
      var groupNames = '';

      if (groupArr.includes('-1')) {
        return '全部用户';
      }

      _this.userGroupOptions.map(function (group) {
        if (groupArr.includes(group.ID + '')) {
          groupNames += group.groupName + group.parentName + ',';
        }
      });

      return groupNames.substr(0, groupNames.length - 1);
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var userGroupOptions, userGroupArr;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getBairunUserGroupInfoAllListByLevel({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 2:
              userGroupOptions = _context.sent;
              userGroupArr = [];
              userGroupOptions.data.list.forEach(function (item) {
                if (item.children && item.children.length > 0) {
                  item.children.forEach(function (item2) {
                    item2.parentName = '(' + item.groupName + ')';
                  });
                  userGroupArr = userGroupArr.concat(item.children);
                } else {
                  item.parentName = '';
                  userGroupArr.push(item);
                }
              });
              _this2.userGroupOptions = userGroupArr;

              _this2.getTableData();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    toTarget: function toTarget(name, id) {
      if (id === null) {
        this.$router.push(name);
      } else {
        this.$router.push({
          name: name,
          params: {
            stationId: id
          }
        });
      }
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    onAddGroupUser: function onAddGroupUser() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择用户记录'
        });
        return;
      }

      this.formData.mobile = this.multipleSelection[0].user.mobile;
      this.formData.userGroupId = this.multipleSelection[0].userGroupId;
      this.type = 'addGroupUser';
      this.userGroupDialogVisible = true;
    },
    onViewQrcode: function onViewQrcode(userQrcodeText) {
      this.userQrcodeText = userQrcodeText;
      this.qrcodeDialogVisible = true;
    },
    closeDialog: function closeDialog() {
      this.userQrcodeText = '';
      this.qrcodeDialogVisible = false;
      this.type = '';
      this.userGroupDialogVisible = false;
      this.formData = {
        mobile: '',
        userGroupId: ''
      };
    },
    // 确定弹窗
    enterDialog: function enterDialog() {
      var that = this;

      switch (that.type) {
        case 'addGroupUser':
          that.$refs.formData.validate( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
              var res;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      debugger;

                      if (!valid) {
                        _context2.next = 6;
                        break;
                      }

                      _context2.next = 4;
                      return changeUserGroup(that.formData);

                    case 4:
                      res = _context2.sent;

                      if (res.code === 0) {
                        that.$message({
                          type: 'success',
                          message: '操作成功!'
                        });
                        that.getTableData();
                        that.closeDialog();
                      }

                    case 6:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
          break;

        default:
          break;
      }
    }
  }
};